import { SzumDrawer } from './SzumDrawer_empty_replacement.js';
import ColorizerStorage from './components/Colorizer/ColorizerStorage';
import SelectedArea from './components/FilterByParameters/SelectedArea';
import FilterGroup from './components/FilterGroup';
import { ModalCollection } from './components/SelectCollection/ModalCollection';
import {
    type FilterColumns,
    FilterColumnsSchema,
    type FilterGroups,
    FilterGroupsSchema,
    type QueriesType,
    QueriesTypeSchema,
    type QueryGeometryType,
} from './types';
import {
    AnalyticsCfgClusterSubMenuSchema,
    AnalyticsCfgSchema,
    FilterSubMenuValueSchema,
} from './types-analytics';
import type { AnalyticsCfg } from './types-analytics';
import {
    API_ObjectAttributesSchema,
    type API_ObjectAttributesType,
    type SzumCredentials,
} from './types-telematics';
import {
    getAnalyticsFilterFromTelematicsFilter,
    getAnalyticsJoinCompareFromFilterRelations,
    getClusterFields,
    getClusters,
    getFilterFromAnalyticsFilter,
    getFilterObjFromAnalyticsFld,
    getFilterRelationsFromAnalyticsJoinCompare,
    getItemsForCluster,
} from './ToolsAnalytics';
import { getAnalyticsFilterFromLastmileFilter } from './ToolsLastMile.js';
import { FilterManager } from './components/FilterByParameters/FilterManager';
import ModalColorizerSetup from './components/Colorizer/ModalColorizerSetup';
import { convertTheViewColorizeToTelematicsData } from './TheViewColorizeConverterFrom';
import { convertTelematicsDataToTheViewColorize } from './TheViewColorizeConverterTo';
import { z } from 'zod';
// import * as filterColumns from './components/FilterByParameters/mocks/filterColumns.json';
// import * as filterGroups from './components/FilterByParameters/mocks/filterGroups.json';
// import * as cfg from './components/FilterByParameters/mocks/cfg_biedronkas.json';
// import * as filterColumns from './components/FilterByParameters/mocks/cfg_2023_column.json';
// import * as filterGroups from './components/FilterByParameters/mocks/cfg_2023_group.json';
//import * as cfg from './components/FilterByParameters/mocks/cfg_2023_biedronkas.json';
import * as lastmileConfigMock from './components/FilterByParameters/mocks/lastmileConfig.json';
import * as TheViewMock from './components/FilterByParameters/mocks/TheView.json';
// import {jobs_filter_config, settings} from "../../../stores/api";
// import {get} from "svelte/store";
import {
    LastMileConfigResponseSchema,
    type LastMileConfigResponseType,
} from '../Settings/settings';
import type { FilterManagerIO } from './components/FilterByParameters/FilterManagerIO';

class FilterAdapter {
    private root: HTMLDivElement;
    private readonly szumDrawer: any;
    private readonly filterManager: FilterManager;
    private filterGroup: FilterGroup | undefined;
    private modalColorizerSetup: ModalColorizerSetup | undefined;
    private dbname: string = '';
    private onChangeFilter: (
        filter: QueriesType,
        andOrSelection: string,
        allQueries: QueriesType,
        changed: boolean
    ) => void;
    // private queries: QueriesType;
    private jobs_filter_config: LastMileConfigResponseType;
    private andOrSelectionEnabled: boolean = false;
    private showButtonRemoveAll: boolean = true;
    private showButtonRestoreFilter: boolean = true;

    constructor(
        root: HTMLDivElement,
        Mapa: any,
        dbname: string,
        // queries: QueriesType,
        jobs_filter_config: LastMileConfigResponseType,
        enableInactiveQueries: boolean,
        andOrSelectionEnabled: boolean,
        filterManagerIO: FilterManagerIO,
        showButtonRemoveAll: boolean,
        showButtonRestoreFilter: boolean,
        onChangeFilter: (
            filter: QueriesType,
            andOrSelection: string,
            allQueries: QueriesType,
            changed: boolean
        ) => void
    ) {
        // console.log('VehicleMonitoring(), constructor(');
        this.root = root;
        this.filterManager = new FilterManager(filterManagerIO);
        this.filterManager.featureInactiveQueries.setEnabled(enableInactiveQueries);
        this.andOrSelectionEnabled = andOrSelectionEnabled;
        this.szumDrawer = new SzumDrawer();
        this.szumDrawer.assignMap(Mapa);
        this.dbname = dbname;
        // this.queries = QueriesTypeSchema.parse(queries);
        this.jobs_filter_config = LastMileConfigResponseSchema.parse(jobs_filter_config);
        this.showButtonRemoveAll = showButtonRemoveAll;
        this.showButtonRestoreFilter = showButtonRestoreFilter;
        this.onChangeFilter = onChangeFilter;
        this.init();
    }

    init() {
        (async () => {
            let TheView = { ...TheViewMock };

            let lastmileConfig = this.jobs_filter_config;
            let cfg = getAnalyticsFilterFromLastmileFilter(lastmileConfig);

            console.log('lastmileConfig', lastmileConfig);
            try {
                LastMileConfigResponseSchema.parse(lastmileConfig);
            } catch (e) {
                console.error(
                    'lastmileConfig given from store is not valid, trying to get default one',
                    e
                );
                try {
                    lastmileConfig = LastMileConfigResponseSchema.parse(lastmileConfigMock);
                } catch (e) {
                    console.error('lastmileConfigMock', e);
                    throw new Error('lastmileConfigMock is not valid');
                }
            }

            ColorizerStorage.loadFromLocalStorage();

            // @ts-ignore $_CFG is a global variable
            this.filterManager.setLocalStorageKeyName__DEPRECATED('filterManager.' + this.dbname);
            await this.filterManager.loadFromLocalStorage({
                loadMainFilter: true,
                loadLastUsedFilter: false,
            });

            this.filterManager.setAndOrSelectionEnabled(this.andOrSelectionEnabled);
            // this.filterManager.getMainFilter().setAvailableValuesAll(lastmileConfig.availableValues);

            console.log('lastmileConfig.availableValues', lastmileConfig.availableValues);
            // this.filterManager.getMainFilter().setAvailableValuesAll({c_pcode: lastmileConfig.availableValues[6] });
            this.filterManager
                .getMainFilter()
                .setAvailableValuesAll(lastmileConfig.availableValues);
            console.log(
                'lastmileConfig.availableValues (from filter)',
                this.filterManager.getMainFilter().getAvailableValuesAll()
            );

            // alert('lastmileConfig.availableValues (from filter)'+JSON.stringify(this.filterManager.getMainFilter().filterQueries )); // OK

            // this.filterManager.getMainFilter().setFilterColumnsAndGroups(

            let $_CFG_FILTER = {
                jobs: [
                    {
                        c_zone1car_cosmetic: {
                            t: 'range',
                            c: '<=',
                            v: ['11'],
                        },
                    },
                ],
                join: [],
                compare: [],
            };

            {
                // this.filterManager.getMainFilter().setFilterQueries(getFilterFromAnalyticsFilter(this.dbname, $_CFG_FILTER).filter);

                // console.log('CONVERT: getFilterFromAnalyticsFilter(this.dbname, $_CFG_FILTER).filter', getFilterFromAnalyticsFilter(this.dbname, $_CFG_FILTER).filter);

                Object.keys(lastmileConfig.clusters).forEach((cluster: string) => {
                    // console.log('cluster', cluster);
                    /*
                          "cluster": "Liczba punktów",
                            "cluster_cfg": {
                            "category": "drogerii",
                            "zone": "dojazdu w ciągu max 5 minut"
                        },
                     */
                    // ex. cluster == "Liczba punktów"
                    let clusterFields = getClusterFields(cluster, cfg);
                    let clusterCFG = lastmileConfig.clusters[cluster];
                    if (!clusterCFG) {
                        clusterCFG = { label: cluster, params: null };
                    }
                    if (Object.keys(clusterFields).length > 0) {
                        this.filterManager
                            .getMainFilter()
                            .updateSubMenuItems(Object.keys(clusterFields)[0], {
                                label: clusterCFG.label,
                                info: clusterCFG.info,
                                cfg: clusterCFG.params,
                                items: getItemsForCluster(cluster, cfg),
                            });
                    } else {
                        console.warn('Found empty cluster: ' + cluster + ' in cfg');
                    }

                    /*
                        c_zone2car_cosmetic: { label: "Liczba punktów", info: "", cfg:
                     */
                });
            }

            // @ts-ignore
            this.filterManager.getMainFilter().setFilterRelated(
                getFilterRelationsFromAnalyticsJoinCompare({
                    join: $_CFG_FILTER.join,
                    compare: $_CFG_FILTER.compare,
                })
            );
            // console.log('getFilterRelated()', this.filterManager.getMainFilter().getFilterRelated());

            // this.filterManager.getLastUsedFilter().setFilter(JSON.parse(localStorage.getItem('filterLastUsed') ?? `[]`));
            /*this.filterManager.loadFromLocalStorage({
                loadMainFilter: false,
                loadLastUsedFilter: true,
            });*/
            // this.filterManager.setFilters(this.queries, this.filterManager.getLastUsedFilter().getFilterQueries());

            // this.filterManager.getMainFilter().setFilterQueries(this.queries);

            // this.filterManager.loadFromLocalStorage();
            this.filterManager
                .getLastUsedFilter()
                .setAvailableValuesAll(this.filterManager.getMainFilter().getAvailableValuesAll());

            // this.onChangeFilter(this.filterManager.getMainFilter().get());
            this.onChangeFilter(
                this.filterManager.getMainFilterActiveQueries(),
                this.filterManager.getAndOrSelection(),
                this.filterManager.getAllQueries(),
                false
            );

            // console.log(
            //     'allAvailableValuesAll, FilterAdapter',
            //     this.filterManager.getMainFilter().getAvailableValuesAll()
            // );

            z.array(API_ObjectAttributesSchema).parse(lastmileConfig.availableTypes);

            this.filterManager
                .getMainFilter()
                .setFilterColumnsAndGroups(
                    lastmileConfig.filterColumns,
                    lastmileConfig.filterGroups
                );

            this.filterManager.getMainFilter().setAvailableTypes(lastmileConfig.availableTypes);

            // @ts-ignore -- Cannot find TheView variable
            if (TheView['colorize']) {
                let TheViewColorize = TheView['colorize'];

                let colorizeUnit = '';
                if (typeof TheViewColorize?.crit?.f !== 'undefined') {
                    colorizeUnit =
                        this.filterManager
                            .getMainFilter()
                            .getAvailableType(TheViewColorize?.crit?.f ?? '')?.unit ?? '';
                }
                console.log(
                    'CONVERT: TheViewColorize',
                    convertTheViewColorizeToTelematicsData(TheViewColorize, colorizeUnit)
                );
                this.modalColorizerSetup = new ModalColorizerSetup(
                    this.root,
                    this.root.querySelector('.js-modal-colorizer-setup') as HTMLDivElement,
                    this.filterManager.getMainFilter(),
                    convertTheViewColorizeToTelematicsData(TheViewColorize, colorizeUnit),
                    {
                        onSave: sliderData => {
                            // @ts-ignore -- Cannot find TheView variable
                            TheView['colorize'] =
                                convertTelematicsDataToTheViewColorize(sliderData);
                            console.log('onSave, sliderData', sliderData);
                            // @ts-ignore -- Cannot find TheView variable
                            console.log("onSave, TheView['colorize']", TheView['colorize']);
                            // Reload color bar and save to DB
                            // jQ('#colorize_control').trigger('onChange');
                            // @ts-ignore -- Cannot find TheView and colorize_helper
                            colorize_helper.updateFilterRangeMenu(TheView['colorize']);
                            // @ts-ignore --
                            colorize_helper.updateColorize();
                            // jQ('#colorize_control').trigger('onChange');
                            // TODO: Refresh legend
                        },
                        onCancel: () => {
                            console.log('onCancel');
                        },
                    }
                );

                let el = document.querySelector(
                    '.telematics-filter-bar-range-menu'
                ) as HTMLDivElement;
                if (el) {
                    el.addEventListener('click', event => {
                        console.debug('show slider colorize page');
                        if (this.modalColorizerSetup) this.modalColorizerSetup.show();
                    });
                }

                document.addEventListener('keydown', event => {
                    // when press Ctrl + Alt + 2, show slider test page
                    if (event.ctrlKey && event.altKey && event.keyCode === 50) {
                        console.debug('show slider colorize page');
                        let el = document.querySelector(
                            '.telematics-filter-bar-range-menu'
                        ) as HTMLDivElement;
                        el.style.display = 'flex';
                    }
                });

                document.addEventListener('telematics-colorize-show', event => {
                    console.debug('show slider colorize page');
                    if (this.modalColorizerSetup) this.modalColorizerSetup.show();
                });
            }

            SelectedArea.setMap(this.szumDrawer.getMap());
            // this.resetGeometry(this.filterManager); // ???

            let $_Collections = [
                // {dbname: 'sklepy', name: 'Sklepy', choosable: true},
                { dbname: 'jobs', name: 'biedronkas', choosable: true },
                { dbname: 'rules', name: 'rules', choosable: true },
            ];
            let collections = [...$_Collections];

            // @ts-ignore -- using global variables
            if (typeof $_Collections.filter(c => c.dbname == this.dbname)[0] === 'undefined') {
                // @ts-ignore -- using global variables
                // alert(`Kolekcja nie została znaleziona: ${this.dbname}`);
                console.warn(`Kolekcja nie została znaleziona: ${this.dbname}`);
            }

            const selectCollectionElement = new ModalCollection(
                this.root.querySelector('.js-modal-collection') as HTMLDivElement,
                {
                    // @ts-ignore -- using global variables
                    defaultItemId: collections.filter(c => c.dbname == cfg.dbname)[0].id,
                    disabled: collections.length < 2,
                    items: collections.filter(c => c.choosable),
                },
                {
                    onChangeItem: collectionId => {
                        for (const i in collections) {
                            if (collections[i].id == collectionId) {
                                this.filterManager.clearLastUsedFilter(); // Do not allow to use last used filter in another collection
                                this.filterManager.saveToLocalStorage();
                                // @ts-ignore -- using global variables
                                jQuery.post(
                                    'index.php?action=rpc_changeDataCollection',
                                    { json_dcid: collectionId },
                                    response => {
                                        if (response.status === 'ok') {
                                            window.location.reload();
                                        }
                                    }
                                );
                                // @ts-ignore -- pwkEvent is undefined
                                pwkEvent('collection', 'switch', collections[i].name);
                                if (this.filterGroup)
                                    this.filterGroup.setCurrentCollection(collections[i]);
                                break;
                            }
                        }
                    },
                    onChangeColor: (collectionId, color) => {
                        console.debug('onChangeColor', collectionId, color); // FIXME: add support
                    },
                    onChangeVisibility: (
                        collectionId: string,
                        visible: boolean,
                        opacity: number
                    ) => {
                        console.debug('onChangeVisibility', collectionId, visible, opacity);
                        // @ts-ignore -- Map is undefined
                        Targeo.Base.Map.modules['modGeoMultiCollection'].setShowCollection(
                            collectionId,
                            visible
                        );
                    },
                }
            );

            // Load filter
            this.filterGroup = new FilterGroup(
                this.root,
                this.root.querySelector('.js-filter-group') as HTMLElement,
                this.szumDrawer,
                this.filterManager,
                this.root.querySelector('.background-under-the-filter') as HTMLElement,
                selectCollectionElement,
                false,
                this.showButtonRemoveAll,
                this.showButtonRestoreFilter,
                {
                    onChangeFilter: async (filter, filterLastUsed, reloadGroup) => {
                        this.filterManager.setFilters(filter, filterLastUsed);
                        await this.filterManager.saveToLocalStorage();
                        // this.resetGeometry(this.filterManager);

                        if (reloadGroup) {
                            if (this.filterGroup) {
                                this.filterGroup.reload();
                            } else {
                                alert('FilterGroup is not defined');
                            }
                        }

                        // @ts-ignore -- $_CFG_FILTER is a global variable
                        $_CFG_FILTER = getAnalyticsFilterFromTelematicsFilter(this.dbname, {
                            filter: this.filterManager.getMainFilter().getFilterQueries(),
                        });

                        let { join, compare } = getAnalyticsJoinCompareFromFilterRelations(
                            this.filterManager.getMainFilter().getFilterRelated()
                        );
                        //console.log('getFilterRelated', this.filterManager.getMainFilter().getFilterRelated());
                        // @ts-ignore -- $_CFG_FILTER is a global variable
                        $_CFG_FILTER.join = join;
                        // @ts-ignore -- $_CFG_FILTER is a global variable
                        $_CFG_FILTER.compare = compare;

                        // @ts-ignore -- $_CFG_FILTER is a global variable
                        // console.log('$_CFG_FILTER', $_CFG_FILTER);

                        // filter_helper.updateFilter();
                        if (this.filterGroup) this.filterGroup.setObjectCounter(12, 13);

                        this.onChangeFilter(
                            this.filterManager.getMainFilterActiveQueries(),
                            this.filterManager.getAndOrSelection(),
                            this.filterManager.getAllQueries(),
                            true
                        );

                        // console.log('getTransmittersIds2, getRequestQuery', JSON.stringify(this.filterManager.getFilter().getRequestQuery()));
                    },
                    onLoadView: () => {},
                    onSaveView: () => {},
                }
            );

            if (!this.filterGroup) {
                alert('FilterGroup is not defined (AAA)');
            }

            this.filterGroup.setObjectCounter(12, 13);

            document.addEventListener('reloadFilter', e => {
                // @ts-ignore -- $_CFG & $_CFG_FILTER are global variables
                this.filterManager
                    .getMainFilter()
                    .setFilterQueries(
                        getFilterFromAnalyticsFilter(this.dbname, $_CFG_FILTER).filter
                    );
                if (this.filterGroup) this.filterGroup.reload();
                if (this.filterGroup) this.filterGroup.setObjectCounter(12, 13);
                this.resetGeometry(this.filterManager);
            });

            document.addEventListener('reloadFilterObjectCounters', e => {
                console.log('reloadFilterObjectCounters');
                if (this.filterGroup) this.filterGroup.setObjectCounter(12, 13);
            });
        })();
    }

    resetGeometry(filterManager: FilterManager): void {
        let geom = filterManager.getMainFilter().getFilterItem('geom') as QueryGeometryType;
        if (geom?.type === 'Polygon' || geom?.type === 'MultiPolygon') {
            SelectedArea.setGeometry(geom);
            // SelectedArea.drawArea();
        } else {
            SelectedArea.resetGeometry();
        }
    }

    destroy(): void {
        console.log('SelectedArea, destroy');
        SelectedArea.resetGeometry();
    }
}

export default FilterAdapter;
